import { render, staticRenderFns } from "./UpdateInventoryLocation.vue?vue&type=template&id=1af4d72b"
import script from "./UpdateInventoryLocation.vue?vue&type=script&lang=js"
export * from "./UpdateInventoryLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports